export const statusConverter = function (status: string) {
  if (status === "FINISHED") {
    return { text: "Finalizado", color: "#656565" };
  } else if (status === "INPROGRESS") {
    return { text: "En Curso", color: "#538802" };
  } else if (status === "INTERVAL") {
    return { text: "Entretiempo", color: "#f08709" };
  }
};
